import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Wrapper, AvatarWrapper, Detail, Title, Subtitle } from './styled'
import { COLORS } from './../DesignConstants'

interface IProps {
  title: string
  subtitle?: string
  image?: any
  icon?: any
  size: number
  principalColor?: string
  background?: string
  borderRadius: number
  fontWeight?: string
}

export const AvatarWithInfo: React.FC<IProps> = ({
  title,
  subtitle,
  image,
  icon,
  size,
  principalColor = COLORS.darkBlue,
  background = COLORS.imageBackground,
  borderRadius,
  fontWeight = 'bold',
}) => {
  const showAvatar = Boolean(image || icon)

  return (
    <Wrapper>
      {showAvatar && (
        <AvatarWrapper
          borderradius={borderRadius}
          background={background}
          src={image}
          size={size}
          icon={icon ? <FontAwesomeIcon icon={icon} /> : undefined}
        />
      )}
      <Detail withAvatar={showAvatar}>
        <Title principalColor={principalColor} fontWeight={fontWeight}>
          {title}
        </Title>
        {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
      </Detail>
    </Wrapper>
  )
}
